const loadState = () => {
  const initialState = {};
  return initialState;
};

export default loadState;
